import { applyMiddleware } from "redux";

import { acrMiddleware } from "@middlewares/acr";
import { aprMiddleware } from "@middlewares/apr";
import { attendanceMiddlewares } from "@middlewares/attendances";
import { employeeMiddleware } from "@middlewares/employee";
import { employeesMiddleware } from "@middlewares/employees";
import { organizationMiddleware } from "@middlewares/organization";
import { retirementMiddleware } from "@middlewares/retirement";
import { retirementsMiddlewares } from "@middlewares/retirements";
import { gpfHistoryMiddleware } from "./gpfHistory";
import { gpfListMiddleware } from "./gpfs";
import { leaveMiddleware } from "./leave";
import { positionMiddleware } from "./position";
import { positionsMiddlewares } from "./positions";
import { positionsInfoMiddlewares } from "./positionsInfo";
import { providentFundMiddlewares } from "./providentFund";
import { providentFundsMiddlewares } from "./providentFunds";
import { punishmentsMiddlewares } from "./punishments";
import { resignationMiddleware } from "./resignation";
import { resignationListMiddleware } from "./resignations";
import { transfersMiddleware } from "./transfers";
import { interchangeTransfersMiddleware } from "./interchangeTransfers";
import thunk from "redux-thunk";

export const middleware = applyMiddleware(
  thunk,
  ...employeeMiddleware,
  ...employeesMiddleware,
  ...organizationMiddleware,
  ...retirementsMiddlewares,
  ...retirementMiddleware,
  ...attendanceMiddlewares,
  ...acrMiddleware,
  ...aprMiddleware,
  ...positionsMiddlewares,
  ...positionsInfoMiddlewares,
  ...positionMiddleware,
  ...providentFundMiddlewares,
  ...providentFundsMiddlewares,
  ...punishmentsMiddlewares,
  ...resignationListMiddleware,
  ...resignationMiddleware,
  ...leaveMiddleware,
  ...gpfListMiddleware,
  ...gpfHistoryMiddleware,
  ...transfersMiddleware,
  ...interchangeTransfersMiddleware,
);
